import type { TripDetail } from '../../types';

export function isAdmin(trip: TripDetail, userId: number | undefined): boolean {
  if (userId == null) {
    return false;
  }
  return trip.admins.some(admin => admin.id === userId);
}
